module.exports = __webpack_public_path__ + "img/16m008-07.385bacec.jpg";